import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-string-html-display',
  templateUrl: './popover-string-html-display.component.html',
  styleUrls: ['./popover-string-html-display.component.scss'],
})
export class PopoverStringHtmlDisplayComponent implements OnInit {

  @Input() data: any;
  dataFromParent: any;

  constructor(
    public popoverController: PopoverController,
    private sanitizer:DomSanitizer
  ){
  }

   onClosePopover = () => {
    this.popoverController.dismiss();
  }

  ngOnInit(): void {
    let message = this.data.message.replace((/  |\r\n|\n|\r/gm),"");
    message = message.replace(/'/g, '');
    message = message.replace(/’/g, '');
    message = message.replace(/"/g, '\'');
    this.dataFromParent = this.sanitizer.bypassSecurityTrustHtml(message);
  }

}
